<template>
  <div class="plv-ia-qn-new-sidebar">
    <div class="plv-ia-qn-new-sidebar-list">
      <div class="plv-ia-qn-new-sidebar-list-title plv-ia-qn-new-sidebar-item">
        {{t('plvIA.questionnaire.questionTypeLabel')}}
      </div>
      <div
        class="plv-ia-qn-new-sidebar-item"
        v-for="(item, index) in questionTypes"
        :key="index"
        @click="addQuestion(item)">
        <span :title="item.name">{{ item.name }}</span>
        <polyv-icon class="plv-ia-qn-new-icon--select" icon="IconSelect" />
      </div>
      <div class="plv-ia-qn-new-sidebar-list-title plv-ia-qn-new-sidebar-item">
        {{t('plvIA.questionnaire.commonlyUsed')}}
      </div>
      <div
        class="plv-ia-qn-new-sidebar-item"
        style="justify-content: flex-start;"
        @click="setPrivacyVisible">
        <span>   {{t('plvIA.questionnaire.privacyAgreement')}}</span>
        <span v-show="ynToBool(questionnaire.privacy.required)" class="plv-ia-privacy-status">( {{t('plvIA.questionnaire.privacyOpenStatues')}})</span>
      </div>
      <div
        v-for="(item, index) in questionModal"
        class="plv-ia-qn-new-sidebar-item"
        :key="index + 'modal'"
        @click="addQuestionModal(item, index)">
        <span>{{ item.name }}</span>
        <polyv-icon class="plv-ia-qn-new-icon--select" icon="IconSelect" />
      </div>
    </div>

    <PrivacyDialog
      ref="privacyDialog"
      :enable="questionnaire.privacy.required"
      :content="questionnaire.privacy.content"
      :tips="t('plvIA.questionnaire.privacyTips')"
      @save="setPrivacy"
    />
  </div>
</template>

<script>
import { getQuestionModel, QUESTION_TYPE } from '@/assets/app/questionnaire/helper';
import PrivacyDialog from './PrivacyDialog';
import Locale from '@/mixins/locale';
import { ynToBool } from '@polyv/utils/src/boolean';
import { PolyvIcon } from '@polyv/icons-vue/icon';

export default {
  name: 'SidebarNew',
  mixins: [Locale],
  components: {
    PrivacyDialog,
    PolyvIcon
  },
  props: {
    editingData: {
      required: true
    }
  },
  data() {
    return {
      questionnaire: this.editingData,
      privacyVisible: false,
      questionTypes: [
        {
          type: QUESTION_TYPE.SINGLE,
          name: this.t('plvIA.questionnaire.singleChoice'),
        },
        {
          type: QUESTION_TYPE.MULTIPLE,
          name: this.t('plvIA.questionnaire.multipleChoice'),
        },
        {
          type: QUESTION_TYPE.STAR,
          name: this.t('plvIA.questionnaire.starRatingQuestions'),
        },
        {
          type: QUESTION_TYPE.TEXT,
          name: this.t('plvIA.questionnaire.fillInTheBlank'),
        },
        {
          type: QUESTION_TYPE.JUDGE,
          name: this.t('plvIA.questionnaire.judgementQuestions'),
        },
      ],
      questionModal: [
        {
          type: QUESTION_TYPE.TEXT,
          name: this.t('plvIA.questionnaire.youName'),
          defaultTitleValue: this.t('plvIA.questionnaire.youName'),
        }, {
          type: QUESTION_TYPE.STAR,
          name: this.t('plvIA.questionnaire.tutorComments'),
          defaultTitleValue: this.t('plvIA.questionnaire.tutorComments'),
        },
        {
          type: QUESTION_TYPE.TEXT,
          name: this.t('plvIA.questionnaire.otherSuggestions'),
          defaultTitleValue: this.t('plvIA.questionnaire.otherSuggestions'),
        }
      ]
    };
  },
  methods: {
    addQuestion(item) {
      const question = getQuestionModel(item.type);
      if (item.type === QUESTION_TYPE.JUDGE) {
        question.options = ['是', '否'];
      }
      this.$emit('add-question', question);
    },
    addQuestionModal(item) {
      const options = {
        name: item.name,
      };
      const question = getQuestionModel(item.type, options);
      this.$emit('add-question', question);
    },
    setPrivacyVisible() {
      this.$refs.privacyDialog.visible = true;
    },
    setPrivacy({ content, enable }) {
      this.questionnaire.privacy.content = content;
      this.questionnaire.privacy.required = enable;
    },
    ynToBool(enabled) {
      if (typeof enabled === 'boolean') return enabled;
      return ynToBool(enabled || 'N');
    }
  }
};
</script>

<style lang="scss">
.plv-ia-qn-new-sidebar {
  width: 160px;
  height: 100%;
  background: #F2F2F2;
  padding: 8px;
  box-sizing: border-box;
  overflow: auto;

  .plv-ia-qn-new-sidebar-item {
    padding: 8px;
    cursor: pointer;
    font-size: 14px;
    color: #333333;
    height: 40px;
    line-height: 24px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    span {
      display: inline-block;
      max-width: 110px;
      // 超出隐藏
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .plv-ia-qn-new-icon--select {
      display: none;
      height: 25px;
      width: 16px;
      svg {
        height: 16px;
        width: 16px;
      }
    }
  }
  .plv-ia-qn-new-sidebar-item:hover {
    background-color: #FFFFFF;
    color: var(--interactBlue);
    display: flex;
    align-items: center;
    justify-content: space-between;
    .polyv-icon {
      display: block !important;
    }
  }

  .plv-ia-qn-new-sidebar-list-title {
    font-size: 12px;
    color: #757575;
  }
  .plv-ia-privacy-status {
    color: var(--interactBlue);
    font-size: 12px;
    margin-left: 7px;
  }
}

</style>
